import { forwardRef, useState } from 'react';
import { Input } from 'reactstrap';

const Integer = forwardRef((props, ref) => {
    let [value, updateValue] = useState(props.value);
    let className = '';

    const handleChange = (element) => {
        const value = element.target.value.replace(/[^0-9]/g, '');  
        if (props.maxLength && value.length > props.maxLength) return;

        updateValue(value);
        if (props?.onChange) props.onChange(element);
    };

    if (props.error) {
        className = 'is-invalid';
    }

    return (
        <div ref={ref}>
            <Input
                id={'id_' + props.name}
                onChange={handleChange}
                className={className}
                value={value}
                type={props.type}
                name={props.name}
                maxLength={props.maxLength ? props.maxLength : 20}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus ? true : false}
                onWheel={(e) => e.target.blur()}
                onBlur={(e) => {
                    if (props.onBlur) props.onBlur(e);
                }}
                {...(props.placeholder !== undefined && { placeholder: props.placeholder })}
            />
            {props.error && (
                <span
                    className="error invalid-feedback"
                    style={{ display: 'inline' }}
                >
                    {props.error}
                </span>
            )}
        </div>
    );
});

export default Integer;